/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { config } from '@uhg-abyss/web/tools/config';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Link } from '@uhg-abyss/web/ui/Link';
import { styled } from '@uhg-abyss/web/tools/styled';
import { PageLayout } from '@src/common/PageLayout';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { useTIN } from '@src/state/taxInformation';
import { useReloadPopup } from '@src/state/reloadPopup/hooks';
import { useUser } from '@src/state/user';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { IconInfo } from '@src/common/MaterialIcon/IconInfo';
import { usePAARegistration } from '@src/state/PAARegistration';
import { useEditing } from '@src/state/editing/hooks';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { event as adobeTaggingEvent } from '@uhg-abyss/web/tools/event';
import { adobeInteraction, getOrgType } from '@src/common/helpers';
import { useOnloading } from '@src/state/landing';
import { useVerifyClaim } from '@src/state/verifyClaim';
import { apiListV2 } from '@src/app/constants/apiList';
import { LagoonContext } from '@src/AppContext/LagoonContext';
import { useDental } from '@src/state/dental';
import { getSuperConnectorApisWithToggles } from '@src/common/APIAccess/APIAccessV2';

import { FLOW_ID } from '@src/common/AppConstants';

const HeaderName = styled('h1', {
  fontSize: '26px',
  fontWeight: 600,
  paddingTop: '20px',
  textAlign: 'left',
  fontFamily: '$heading',
  color: '$primary1',
  marginBottom: '6px',
});

const SubheaderName = styled('p', {
  fontSize: '20px',
  paddingTop: '25px',
  textAlign: 'left',
  fontWeight: 'bold',
  marginBottom: '3px',
  color: '$primary1',
});

const TopInstruction = styled('p', {
  fontWeight: 700,
  textAlign: 'left',
  fontFamily: '$primary',
  marginBottom: '0px !important',
});

const PrimaryAdministratorMessage = styled('div', {
  paddingTop: '10px',
});

const DetailContainer = styled('p', {
  display: 'flex',
  justifyContent: 'space-between',
  paddingTop: '5px',
});

const NameAndNumber = styled('p', {
  paddingTop: '5px',
});

const EmailAndJobFunction = styled('p', {
  paddingTop: '5px',
});

const TitleHeader = styled('p', {
  marginRight: '150px',
  textAlign: 'left',
  fontFamily: '$primary',
  marginBottom: '0px !important',
});

const Name = styled('p', {
  marginRight: '5px',
  fontWeight: 700,
  textAlign: 'left',
  fontFamily: '$primary',
  marginBottom: '0px !important',
});

const SecondaryTitleHeader = styled('p', {
  marginRight: '150px',
  textAlign: 'left',
  marginTop: '20px',
  fontFamily: '$primary',
  marginBottom: '0px !important',
});

const EmailPhoneAndJob = styled('p', {
  display: 'inlineBlock',
  flexDirection: 'column',
  marginRight: '5px',
  fontWeight: 700,
  textAlign: 'left',
  fontFamily: '$primary',
  marginBottom: '0px !important',
});

const Email = styled('p', {
  marginRight: '5px',
  fontWeight: 700,
  textAlign: 'left',
  fontFamily: '$primary',
  marginBottom: '0px !important',
});

const NumberHeader = styled('p', {
  marginRight: '5px',
  textAlign: 'left',
  marginTop: '20px',
  fontFamily: '$primary',
  marginBottom: '0px !important',
  width: '100%',
});

const PagelayoutContainer = {
  marginRight: '0px',
  marginTop: '25px',
};

const Container = {
  width: '725px',
  border: '1px solid rgb(219, 219, 219)',
  backgroundColor: 'white',
  padding: '0px 35px 20px 35px',
};

const AccountAndAdditionalInfo = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline',
  borderBottom: 'solid 0.5px lightgray',
};

const APIAccessEdit = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline',
  borderBottom: 'solid 0.5px lightgray',
});

const ButtonView = styled('div', {
  display: 'flex',
  margin: 'auto',
  marginTop: '15px',
  width: '725px',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

const BackButton = styled('div', {
  width: '115px',
  padding: '6px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  borderWidth: '2.5px',
  border: '2px solid $primary1',
  background: '$white',
  borderStyle: 'solid',
  borderRadius: '23px',
  marginTop: 'auto',
  marginBottom: '20px',
  alignItems: 'center',
  '&:hover': {
    cursor: 'pointer',
  },
});

const BackButtonText = styled('text', {
  color: '$primary1',
  fontWeight: 'bold',
  marginLeft: '12px',
  fontSize: '16px',
});

const NextButton = styled('div', {
  width: '115px',
  padding: '6px',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'row',
  borderWidth: '2.5px',
  border: '2px solid $primary1',
  background: '$primary1',
  borderStyle: 'solid',
  borderRadius: '23px',
  marginTop: 'auto',
  marginBottom: '20px',
  alignItems: 'center',
  '&:hover': {
    cursor: 'pointer',
  },
});

const NextButtonText = styled('text', {
  color: '$white',
  fontWeight: 'bold',
  marginRight: '12px',
  fontSize: '16px',
});

const ChangeLink = styled('div', {
  textAlign: 'right',
});

const ModalButtonView = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '0 20px',
});

const ModalBackButton = styled('div', {
  width: '122px',
  padding: '6px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  borderWidth: '2.5px',
  border: '2px solid $primary1',
  background: '$white',
  borderStyle: 'solid',
  borderRadius: '23px',
  marginTop: 'auto',
  marginBottom: '20px',
  alignItems: 'center',
  '&:hover': {
    cursor: 'pointer',
  },
});

const ModalBackButtonText = styled('text', {
  color: '$primary1',
  fontWeight: 'bold',
  fontSize: '16px',
});

const ModalNextButton = styled('div', {
  width: '122px',
  padding: '6px',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'row',
  borderWidth: '2.5px',
  border: '2px solid $primary1',
  background: '$primary1',
  borderStyle: 'solid',
  borderRadius: '23px',
  marginTop: 'auto',
  marginBottom: '20px',
  alignItems: 'center',
  '&:hover': {
    cursor: 'pointer',
  },
});

const ModalNextButtonText = styled('text', {
  color: '$white',
  fontWeight: 'bold',
  fontSize: '16px',
});

const Ext = styled('span', {
  fontWeight: 'normal',
  marginLeft: '5px',
});

const List = styled('ul', {
  'list-style': 'none',
});

const ListItem = styled('li', {
  'list-style-type': 'none',
  fontWeight: 'bold',
});

const ListApiAccess = styled('ul', {
  'list-style': 'disc',
  paddingLeft: '25px',
});

const ListItemApiAccess = styled('li', {
  'list-style-type': 'disc',
  marginRight: '5px',
  fontWeight: 700,
  textAlign: 'left',
  fontFamily: '$primary',
  marginBottom: '0px !important',
});

const APIText = styled('div', {
  marginRight: '5px',
  fontWeight: 700,
  textAlign: 'left',
  fontFamily: '$primary',
  marginBottom: '0px !important',
});

const APIUseText = styled('div', {
  marginRight: '5px',
  fontWeight: 700,
  textAlign: 'left',
  fontFamily: '$primary',
  marginBottom: '0px !important',
  whiteSpace: 'pre-wrap',
  wordWrap: 'break-word',
  width: '610px !important',
});

export const PAAReviewConfirm = ({ handleBack }) => {
  const form = useForm();
  const { token } = useParams();
  const [flyoutModalOpen, setFlyoutModalOpen] = useState(false);
  const { firstName, lastName, email } = useUser.state();

  const lagoonContext = React.useContext(LagoonContext);
  const featureToggles = lagoonContext.getTable('feature-toggles');
  const uiMessages = lagoonContext.getTable('ui-messaging');
  const { isDental } = useDental.state();

  const {
    selectedJobFunctions,
    phone,
    phoneExt,
    apiListSelection,
    apiUseText,
    selectedApiCodes,
  } = usePAARegistration.state();
  const { setMainRadioGroup } = useVerifyClaim.actions();
  const jobFunctionKeys = Object.keys(selectedJobFunctions || {});
  const { submitTINRequest } = usePAARegistration.actions();
  const { setIsEditing } = useEditing.actions();
  const { TINNumber, TINInfo } = useTIN.state();
  const { setReloadPopup } = useReloadPopup.actions();
  const router = useRouter();
  const { currentFlow } = useOnloading.state();
  const { userUUID, isAPIMarketPlaceUser } = useUser.state();
  const apiUserType = currentFlow.includes('technician')
    ? 'API Consumer'
    : 'Secret Keeper';
  const onChangeAdministrator = () => {
    setIsEditing(true);
    setMainRadioGroup('');
    adobeInteraction(
      'change paa',
      'yes',
      currentFlow,
      featureToggles.getRow('ADOBE_ANALYTICS_TRACKING')?.active
    );
    router.navigate(`/PAARegistration/home/${token}`);
  };

  const tinInfo = TINInfo == null ? { corpName: 'ABC Hopsital' } : TINInfo;

  const onEdit = (path) => {
    setIsEditing(true);
    adobeInteraction(
      'review and confirm',
      'edit',
      currentFlow,
      featureToggles.getRow('ADOBE_ANALYTICS_TRACKING')?.active
    );
    router.navigate(`/PAARegistration/${path}/${token}`);
  };
  const handleConfirm = () => {
    setReloadPopup(false);

    const handleError = () => {
      router.navigate(`/error-page/${token}`);
    };

    const processResponse = () => {
      if (isAPIMarketPlaceUser) {
        router.navigate(`/Registration/EmailConfirmation/${token}`);
        return;
      }

      adobeInteraction(
        'review and confirm',
        'confirm',
        currentFlow,
        featureToggles.getRow('ADOBE_ANALYTICS_TRACKING')?.active
      );
      window.location.href =
        uiMessages.getRow('SDE_URL')?.message || config('SDE_URL');
    };

    let arrayOfSelectedJobs = [];
    let renamedJobFunctions = [];
    let rcmIndicator = false;
    let rcmCompanyName = '';

    arrayOfSelectedJobs = jobFunctionKeys.map((key) => {
      return selectedJobFunctions[key];
    });
    renamedJobFunctions = arrayOfSelectedJobs.map((item) => {
      const jobFunction = { code: item.code, npi: item.npiValue || '' };
      if (item.RCMValue) {
        rcmIndicator = item.RCMValue === 'Y';
        rcmCompanyName = item.RCMValue === 'Y' ? item.companyName : undefined;
      }
      return jobFunction;
    });

    const jobs =
      renamedJobFunctions.length > 0
        ? { jobFunctions: renamedJobFunctions }
        : {};

    let apiMarketPlaceFields = {};
    const orgType = getOrgType(currentFlow);

    const selectedAPICodesV1 = apiListSelection
      .filter((api) => {
        return api.selected;
      })
      .map((api) => {
        return api.code;
      });

    if (featureToggles.getRow('US8482146_SUPER_CONNECTOR')?.active) {
      apiMarketPlaceFields = {
        apiRequested: selectedApiCodes,
        comments: apiUseText,
      };
    } else if (selectedAPICodesV1.length > 0) {
      apiMarketPlaceFields = {
        apiRequested: selectedAPICodesV1,
        comments: apiUseText,
      };
    }

    form.validate('PAARegistration/POST_SUBMISSION', () => {
      const payload = {
        url:
          uiMessages.getRow('REGISTER_API')?.message || config('REGISTER_API'),
        requestId: TINInfo.requestId,
        currentFlow,
        phoneNumber: phone,
        phoneExt,
        rcmIndicator,
        rcmCompanyName,
        ...jobs,
        ...apiMarketPlaceFields,
        isDental,
      };
      submitTINRequest(
        payload,
        (response) => {
          if (response.error) {
            if (featureToggles.getRow('ADOBE_ANALYTICS_TRACKING')?.active) {
              adobeTaggingEvent('API_TRANSACTION_ERROR', {
                errorMessage: response.error.description,
                errorApiCode: response.error.code,
                errorHttpsCode: response.error.status,
              });
            }
            handleError();
            return;
          }
          if (featureToggles.getRow('ADOBE_ANALYTICS_TRACKING')?.active) {
            adobeTaggingEvent('TIN_REGISTRATION_COMPLETION', {
              jobName: `tin registration-${orgType}`,
              orgType,
              jobFunctions:
                (arrayOfSelectedJobs &&
                  arrayOfSelectedJobs
                    .map((p) => {
                      return p.name;
                    })
                    .toString()) ||
                '',
              portalTaskAccess: '',
              providerUuid: userUUID,
              registrationTaxId: TINNumber,
              rcmOrBillingFlag: rcmIndicator === false ? 'No' : 'Yes',
              companyName: rcmCompanyName,
            });
          }
          processResponse();
        },
        handleError
      );
    });
  };

  useEffect(() => {
    if (featureToggles.getRow('ADOBE_ANALYTICS_TRACKING')?.active) {
      const orgType = getOrgType(currentFlow);
      const section1 = 'paa registration';
      const section2 = 'review and confirm';
      const pageName = `digitalsecurity:${section1}:${section2}`;

      adobeTaggingEvent('ON_PAGE_LOAD', {
        pageName,
        orgType,
        organization: tinInfo?.corpName,
        uuid: userUUID,
        tin: TINNumber,
        section1,
        section2,
        section3: '',
      });
    }
  }, []);

  // Get the enabled Super Connector APIs dynamically
  const dynamicSuperConnectorApis =
    getSuperConnectorApisWithToggles(featureToggles);

  // Use selectedApiCodes if present, otherwise build from apiListSelection
  const selectedCodes =
    selectedApiCodes && selectedApiCodes.length > 0
      ? selectedApiCodes
      : apiListSelection
          .filter((api) => {
            return api.selected;
          })
          .map((api) => {
            return api.code;
          });

  // Codes for currently enabled Super Connector APIs
  const superConnectorApiCodes = dynamicSuperConnectorApis.map((api) => {
    return api.code;
  });

  // Selected Super Connector APIs (with toggles)
  const superConnectorApiSelections = dynamicSuperConnectorApis.filter(
    (api) => {
      return selectedCodes.includes(api.code);
    }
  );

  // Selected regular APIs (not Super Connector)
  const regularApiSelections = apiListV2.filter((api) => {
    return (
      selectedCodes.includes(api.code) &&
      !superConnectorApiCodes.includes(api.code)
    );
  });

  // For fallback if selectedApiCodes is empty
  const selectedAPIs = apiListSelection.filter((api) => {
    return api.selected;
  });

  return (
    <PageLayout style={PagelayoutContainer}>
      <Flex.Content className="Container" style={Container}>
        <HeaderName>
          Review and confirm that your information is correct.
        </HeaderName>
        <Modal
          size="md"
          isOpen={flyoutModalOpen}
          showCloseButton={false}
          onClose={() => {
            return setFlyoutModalOpen(false);
          }}
          title={
            !isAPIMarketPlaceUser
              ? `Are you sure you want to change the Primary Access Administrator?`
              : `Are you sure you want to change the ${apiUserType}?`
          }
        >
          <Modal.Section>
            <p>
              If you go back, your progress will <b>not</b> be saved.
            </p>
          </Modal.Section>
          <ModalButtonView>
            <ModalBackButton
              onClick={() => {
                adobeInteraction(
                  'change paa',
                  'no',
                  currentFlow,
                  featureToggles.getRow('ADOBE_ANALYTICS_TRACKING')?.active
                );
                setFlyoutModalOpen(false);
              }}
            >
              <ModalBackButtonText>No</ModalBackButtonText>
            </ModalBackButton>
            <ModalNextButton onClick={onChangeAdministrator}>
              <ModalNextButtonText>Yes</ModalNextButtonText>
            </ModalNextButton>
          </ModalButtonView>
        </Modal>
        {apiUserType !== 'API Consumer' && (
          <PrimaryAdministratorMessage>
            <Flex>
              <div
                style={{
                  width: '5%',
                }}
              >
                <IconInfo />
              </div>
              <div
                style={{
                  width: '80%',
                }}
              >
                {!isAPIMarketPlaceUser ? (
                  <TopInstruction>
                    You have identified yourself as the Primary Access
                    Administrator for {tinInfo.corpName}
                  </TopInstruction>
                ) : (
                  <TopInstruction>
                    You have identified yourself as the {apiUserType} for{' '}
                    {tinInfo.corpName}
                  </TopInstruction>
                )}
              </div>
              <div
                style={{
                  width: '15%',
                }}
              >
                <ChangeLink>
                  <Link
                    color="$accent1"
                    fontWeight="bold"
                    onClick={() => {
                      adobeInteraction(
                        'review and confirm',
                        'change',
                        currentFlow,
                        featureToggles.getRow('ADOBE_ANALYTICS_TRACKING')
                          ?.active
                      );
                      setFlyoutModalOpen(true);
                    }}
                    aria-label="click here to Change your Primary Access Administrator"
                  >
                    Change
                  </Link>
                </ChangeLink>
              </div>
            </Flex>
          </PrimaryAdministratorMessage>
        )}
        <div style={AccountAndAdditionalInfo}>
          <SubheaderName>Account Information</SubheaderName>
          <Link
            color="$accent1"
            fontWeight="bold"
            onClick={() => {
              return onEdit('accountInfo');
            }}
            aria-label="click here to edit Account Information"
          >
            Edit
          </Link>
        </div>
        <DetailContainer>
          <Flex
            css={{
              'abyss-flex-root': {
                width: '100%',
              },
            }}
          >
            <div
              style={{
                width: '50%',
              }}
            >
              <NameAndNumber>
                <div>
                  <TitleHeader>Name</TitleHeader>
                  <Name>
                    {firstName} {lastName}
                  </Name>
                </div>
                <div>
                  <NumberHeader>Work Phone Number</NumberHeader>
                  <EmailPhoneAndJob>
                    {phone} {phoneExt && <Ext> ext.</Ext>}{' '}
                    {phoneExt && phoneExt}
                  </EmailPhoneAndJob>
                </div>
              </NameAndNumber>
            </div>
            <div
              style={{
                width: '50%',
              }}
            >
              <EmailAndJobFunction>
                <div>
                  <TitleHeader>Email Address</TitleHeader>
                  <Email>{email}</Email>
                </div>
                {jobFunctionKeys.length > 0 && (
                  <div>
                    <SecondaryTitleHeader>
                      Job Function
                      {jobFunctionKeys.length > 1 && 's'}
                    </SecondaryTitleHeader>
                    <EmailPhoneAndJob>
                      {selectedJobFunctions && (
                        <List>
                          {jobFunctionKeys.map((key) => {
                            return (
                              <ListItem key={key}>
                                {selectedJobFunctions[key].name}
                                {selectedJobFunctions[key].npiValue &&
                                  `, NPI: ${selectedJobFunctions[key].npiValue}`}
                              </ListItem>
                            );
                          })}
                        </List>
                      )}
                    </EmailPhoneAndJob>
                  </div>
                )}
              </EmailAndJobFunction>
            </div>
          </Flex>
        </DetailContainer>
        {currentFlow !== FLOW_ID.API_MARKETPLACE_PROVIDER && (
          <React.Fragment>
            <div style={AccountAndAdditionalInfo}>
              <SubheaderName>
                Helpful Resources for Primary Access Administrators
              </SubheaderName>
            </div>
            <DetailContainer>
              <Flex
                css={{
                  'abyss-flex-root': {
                    width: '100%',
                  },
                }}
              >
                <div
                  style={{
                    width: '50%',
                  }}
                >
                  <Link href={config('CREATE_MANAGE_USERS_GUIDE')}>
                    How to create and manage users
                  </Link>
                </div>
                <div
                  style={{
                    width: '50%',
                  }}
                >
                  <Link href={config('THIRD_PARTY_GROUP_ACCESS_GUIDE')}>
                    3rd Party Access guide
                  </Link>
                </div>
              </Flex>
            </DetailContainer>
          </React.Fragment>
        )}

        {currentFlow === FLOW_ID.API_MARKETPLACE_PROVIDER && (
          <React.Fragment>
            <APIAccessEdit>
              <SubheaderName>API Access</SubheaderName>
              <Link
                color="$accent1"
                fontWeight="bold"
                onClick={() => {
                  return onEdit('apiAccess');
                }}
                aria-label="click here to edit API access"
              >
                Edit
              </Link>
            </APIAccessEdit>
            <DetailContainer>
              <Flex>
                <Flex.Content space-100>
                  <NumberHeader>API Access</NumberHeader>
                  {dynamicSuperConnectorApis.length > 0 ? (
                    <React.Fragment>
                      {superConnectorApiSelections.length > 0 && (
                        <React.Fragment>
                          <APIText>Super Connector</APIText>
                          <ListApiAccess>
                            {superConnectorApiSelections.map((api) => {
                              return (
                                <ListItemApiAccess key={api.code}>
                                  {api.description}
                                </ListItemApiAccess>
                              );
                            })}
                          </ListApiAccess>
                        </React.Fragment>
                      )}
                      {regularApiSelections.map((api) => {
                        return (
                          <APIText key={api.code}>{api.description}</APIText>
                        );
                      })}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {selectedAPIs.map((api) => {
                        return (
                          <APIText key={api.code}>{api.description}</APIText>
                        );
                      })}
                    </React.Fragment>
                  )}
                </Flex.Content>
                <Flex.Content space-100>
                  <NumberHeader>Intended use for this API</NumberHeader>
                  <APIUseText>{apiUseText}</APIUseText>
                </Flex.Content>
              </Flex>
            </DetailContainer>
          </React.Fragment>
        )}
      </Flex.Content>
      <Flex.Content>
        <ButtonView>
          <BackButton onClick={handleBack}>
            <IconSymbol icon="arrow_back" size={20} color="$primary1" />
            <BackButtonText>Back</BackButtonText>
          </BackButton>
          <NextButton onClick={handleConfirm}>
            <NextButtonText>Confirm</NextButtonText>
            <IconSymbol icon="arrow_forward" size={16} color="$primary2" />
          </NextButton>
        </ButtonView>
      </Flex.Content>
    </PageLayout>
  );
};

PAAReviewConfirm.propTypes = {
  handleBack: PropTypes.func.isRequired,
};
